import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { UserList } from "./user-list";

export function Users() {
  return (
    <>
      <Routes>
        <Route index element={<Navigate replace to="list" />} />
        <Route element={<UserList />} path="/list/*" />
      </Routes>
      <Outlet />
    </>
  );
}
